import { HandleData } from '@core/app/scripts/services/handle-data';
import { IsE2e } from '@core/app/scripts/services/is-e2e';

export class TimeKeeper {
  _date: null;
  _sysMSAtPing: null;

  constructor(
    private $log: ng.ILogService,
    private $timeout: ng.ITimeoutService,
    private isE2e: IsE2e,
    private handleData: HandleData,
  ) {}

  getDate = () => {
    const success = (r) => {
      if (!r || !r.local_time) {
        // @ts-ignore
        this._date = '';
        this.$log.error('[timeKeeper] Could not get time from server!');
        this.startTimeout(60000);
        return;
      }
      this._date = r.local_time;
      // @ts-ignore
      this._sysMSAtPing = Date.now();
      //15min
      this.startTimeout(900000);
    };

    const error = () => {
      // @ts-ignore
      this._errorCount++;
      // @ts-ignore
      this._date = '';
      this.$log.error('[timeKeeper] Could not get time from server!');
      //change to use the handledata retry
      this.startTimeout(60000);
    };
    this.handleData.time(success, error);
  };

  startTimeout = (t) => {
    // TODO use $interval when updating to ng 1.2+, otherwise $timeout cause the e2e to wait for ever
    if (!this.isE2e) {
      this.$timeout(this.getDate, t);
    }
  };

  init = (tz) => {
    //Init the timeout
    this.getDate();
  };

  getLocalDate = () => {
    let d = Date.parse(this._date);

    const dateRef = this._sysMSAtPing;
    //If parsing fails, use local date
    if (isNaN(d) || isNaN(dateRef)) {
      d = Date.now();
      this.$log.log(
        '[TimeKeeper] Parsing failed, using local date',
        this._date,
      );
    } else {
      //diff between ping and now
      // @ts-ignore
      const diff = Date.now() - this._sysMSAtPing;
      d = Date.parse(this._date) + diff;
    }

    return new Date(d);
  };
}

/*
 * Handle getting the correct date and time from the server using the time endpoint
 */
angular
  .module('v6CoreModule')
  .service(
    'timeKeeper',
    (
      $log: ng.ILogService,
      $timeout: ng.ITimeoutService,
      isE2e: IsE2e,
      handleData: HandleData,
    ) => {
      return new TimeKeeper($log, $timeout, isE2e, handleData);
    },
  );
